// extracted by mini-css-extract-plugin
export default {"section":"vYNqaN","section_title":"S2mqHe","sectionTitle":"S2mqHe","section_text":"GwpLsI","sectionText":"GwpLsI","toggle":"TSiC1t"};